import { z } from 'zod';

/**
 * Схемы `POST /share/prepare` для API контракта (Веха 6).
 *
 * Источник правды:
 *   - work/006 §M1.6 (ingress) — `kind: 'invite' | 'answer'` discriminatedUnion.
 *   - security/threat-models/notify-and-share.md → S3 (strict-mode parsing at boundary):
 *     каждый вариант discriminatedUnion + response должны быть `.strict()`.
 *   - CANON §2.D (zod-strict) + ARCHITECTURE_PLAN §6.4 (savePreparedInlineMessage).
 *
 * Контракт endpoint:
 *   - `kind: 'invite'` — клиент уже под `requireAuth`, бокс ищется через
 *     `findBoxForOwner(tgUser.id)` на сервере (никакого `boxToken` в body —
 *     threat-model E «findBoxForOwner для invite»).
 *   - `kind: 'answer'` — клиент передаёт свой `answerId`; ownership-check
 *     `answer.question.box.ownerId === tgUser.id` на сервере (threat-model E
 *     «ownership-check для answer»).
 *   - Response: `preparedMessageId` от Bot API `savePreparedInlineMessage` +
 *     `expiresAt` (ISO-8601) — поле `expiration_date` от Telegram, конвертированное
 *     в ISO для удобства клиента.
 */
export const PrepareShareBody = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('invite') }).strict(),
  z
    .object({
      kind: z.literal('answer'),
      answerId: z.string().min(1).max(64),
    })
    .strict(),
]);
export type PrepareShareBody = z.infer<typeof PrepareShareBody>;

/**
 * Response для `POST /share/prepare`. Strict — никаких unknown полей.
 *
 * `expiresAt` — ISO-8601 datetime (Telegram отдаёт `expiration_date` как unix
 * timestamp, сервер конвертирует через `new Date(...).toISOString()`).
 */
export const PrepareShareResponse = z
  .object({
    preparedMessageId: z.string().min(1),
    expiresAt: z.string().datetime(),
  })
  .strict();
export type PrepareShareResponse = z.infer<typeof PrepareShareResponse>;
